import { ERolesCode } from "../../../../../routes/role-catalog";

export const isValidToUpload = [
  ERolesCode.ADMINISTRATOR,
  ERolesCode.PARTNER,
  ERolesCode.ANALYST,
  ERolesCode.STARTUP,
  ERolesCode.SUPER_ADMIN,
];
